var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mac/Monochrome/17x17/img.trash.empty.filled.17",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(2 1)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.846 4l-.662 8.607c-.065.85-.172 1.153-.354 1.456a1.812 1.812 0 01-.751.696c-.317.158-.626.241-1.48.241H4.4c-.853 0-1.162-.083-1.479-.241a1.812 1.812 0 01-.751-.696c-.182-.303-.289-.606-.354-1.456L1.154 4h10.692z",
    id: "Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5A.5.5 0 01.494 2h12.012a.5.5 0 010 1H.494A.502.502 0 010 2.5z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0c.552 0 1 .443 1 .999V3H4V.999A.997.997 0 015 0h3zM5 2h3V1H5v1z",
    id: "Rectangle-2",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash17);
export default __webpack_public_path__ + "static/media/trash-17.db4f59bf.svg";
export { ForwardRef as ReactComponent };